import React from 'react';
import styled from 'styled-components'
import { createClassNameList } from '../utils/helpers'

interface Props {
	onChange: (id: string) => void,
	name: string,
	values: any[],
	disabled: boolean;
	currentValue: any;
	updating: boolean;
};

const RadioButton = styled.div`
	/* The container */
	.container {
		display: block;
		position: relative;
		padding-left: 65px;
		padding-top: 15px;
		padding-bottom: 15px;
		margin-bottom: 0px;
		cursor: pointer;
		font-size: 22px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		border-color: lightgray;
		border-width: 1px;
		border-bottom-style: solid;
	}
	/* Hide the browser's default radio button */
	.container input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
	}
	/* Create a custom radio button */
	.checkmark {
		position: absolute;
		top: 22px;
		left: 20px;
		height: 24px;
		width: 24px;
		background-color: white;
		border-radius: 50%;
		border-color: red;
		border-style: solid;
		border-width: 2px;
		border-height: 2px;
	}
	.container:hover input ~ .checkmark:not(.disabled-or-updating) {
		background-color: #eee;
	}
	.container input:checked ~ .checkmark {
		background-color: white;
	}
	/* Create the indicator (the dot/circle - hidden when not checked) */
	.checkmark:after {
		content: "";
		position: absolute;
		display: none;
	}
	/* Show the indicator (dot/circle) when checked */
	.container input:checked ~ .checkmark:after {
		display: block;
	}
	/* Style the indicator (dot/circle) */
		.container .checkmark:after {
		top: 50%;
		left: 50%;
		width: 14px;
		height: 14px;
		border-radius: 80%;
		background: red;
		margin-top: -7px;
		margin-left: -7px;
	}
	.container .checkmark.disabled-or-updating:after {
		background: lightgray;
	}
	.container .gray-text {
		color: darkgray;
		font-size: 1rem;
		line-height: 1.3;
	}
	.container .title {
		color: #4c4c4c;
		font-weight: 300;
		font-size: 1.25rem;
	}
	.container .title.disabled-or-updating {
		color: lightgray
	}
}
`;

const RedText = styled.div`
	padding: 5px;
	color: red;
`;

const createInput = (disabled: boolean, name: string, buttonId: string, onChange: (id: string) => void, currentValue: any, updating: boolean) => (
	<input
		type="radio" id={buttonId} checked={currentValue === buttonId} disabled={(disabled||updating)}  name={name}
		value={buttonId} onChange={() => { if (currentValue !== buttonId) onChange(buttonId) }}
	/>
);

export const RadioButtons: React.FC<Props> = (props: Props) => (
	<div>
		{props.updating && (
			<RedText>Asetusta päivitetään</RedText>
		)}
		<form>
			{props.values.map((value: any) => (
				<RadioButton key={value.buttonId} >
					<label className="container" htmlFor={value.buttonId} >
						{createInput(props.disabled, props.name, value.buttonId, props.onChange, props.currentValue, props.updating)} <span className={createClassNameList(['title', (props.disabled || props.updating) ? 'disabled-or-updating' : undefined])}>{value.displayName}</span> <br />
						<span className={createClassNameList(['checkmark', (props.disabled || props.updating) ? 'disabled-or-updating' : undefined])} />
						<div className="gray-text" >{value.displaytext}</div>
					</label>
				</RadioButton>
			))}
		</form>
	</div>
);